import type { SelectOptions } from '@library/types/utils';

export const PER_PAGE_OPTIONS: SelectOptions = [
  { key: '10', name: '10', value: '10' },
  { key: '25', name: '25', value: '25' },
  { key: '50', name: '50', value: '50' },
  { key: '100', name: '100', value: '100' },
  { key: '200', name: '200', value: '200' }
];
